import { useEffect } from "react";
import { useAlert } from "../../../../src/context/AlertContext";
import { ALERT_OK } from "../../../components/iconsSVG/IconsSVG";
import { AlertRenderer } from "../../../../src/components/alert/AlertRenderer";
import { Link } from "react-router-dom";
import {VOLVER} from "../../../components/iconsSVG/IconsSVG.jsx";

const SuscripcionCancelada = () => {

  const { showAlert } = useAlert(); // obtenemos la función del contexto

  useEffect(() => {
    showAlert({
      tipo: "success",
      titulo: "Éxito",
      msg: "El usuario ha sido dado de baja con éxito.",
      customIcon: <ALERT_OK/>
    });
  }, [showAlert]); // solo se ejecuta una vez al montar  
  
  return (
    <div className="p-0 m-2">
      <div className="m-2 p-0 d-flex justify-content-end">
        <Link to="/buscador" className="btn m-0 p-0 me-3 btn-volver text-end">
          <VOLVER strokeWidth={1.5} width={"24px"} height={"16px"}/>{" "} VOLVER A CONSULTA BOPI
        </Link>
      </div>
      <br></br>
      <h4>Verificación de baja del Boletín Oficial de la Propiedad Industrial</h4>      
      {/* ESTO ES PARA MOSTRAR LA ALERTA */}
      <AlertRenderer />
    </div>
  );
};

export default SuscripcionCancelada;